import type { Post } from '@/@types/post'

import { LIKE_LOTTIE_DATA_QUERY_OPTIONS } from '@/utils/fetchers/manifest'
import { css } from '@emotion/react'
import { LikeIcon } from '@ruguoapp/jike-fe-icons'
import { useQuery } from '@tanstack/react-query'
import { get, isEqual } from 'lodash-es'
import type { AnimationItem } from 'lottie-web'
import { type HTMLAttributes, type SyntheticEvent, memo, useRef } from 'react'
import Lottie from 'react-lottie-player'

export interface DynamicLikeIconProps extends HTMLAttributes<HTMLDivElement> {
	data: Post
	onClick?: (e: SyntheticEvent<Element>) => void
}

export default memo(function DynamicLikeIcon({ data, ...props }: DynamicLikeIconProps) {
	const liked = !!data.liked
	const playerRef = useRef<AnimationItem | null>(null)

	const { data: lottieData } = useQuery({
		...LIKE_LOTTIE_DATA_QUERY_OPTIONS,
		select: (likeLottieDataMap) => get(likeLottieDataMap, data.likeIcon!),
		enabled: !!data.likeIcon,
	})

	if (!data.likeIcon || !lottieData) {
		return (
			<LikeIcon
				css={css`
					margin: 0 8px;
				`}
				{...(props as HTMLAttributes<SVGSVGElement>)}
			/>
		)
	}

	return (
		<Lottie
			play
			loop={false}
			ref={playerRef}
			animationData={lottieData.data}
			segments={liked ? lottieData.selectSegment : lottieData.unselectSegment}
			goTo={liked ? lottieData.unselectStart : lottieData.selectStart}
			css={css`
				width: 36px !important;
				height: 36px !important;
			`}
			{...props}
		/>
	)
}, isEqual)
